import { useState } from "react";

interface ChecklistItemProps {
  number: number;
  title: string;
  tag?: string;
  checked: boolean;
  onToggle: () => void;
  children: React.ReactNode;
}

export default function ChecklistItem({
  number,
  title,
  tag,
  checked,
  onToggle,
  children,
}: ChecklistItemProps) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div
      className={`rounded-lg border transition-all duration-200 overflow-hidden ${
        checked
          ? "border-[#2C7A4B] bg-[#f0faf5]"
          : "border-background-200 bg-background-50"
      }`}
    >
      {/* Header Row */}
      <div className="flex items-center gap-3 px-4 py-4">
        {/* Checkbox */}
        <button
          onClick={onToggle}
          className={`flex-shrink-0 w-6 h-6 rounded flex items-center justify-center border-2 transition-all cursor-pointer ${
            checked
              ? "bg-[#2C7A4B] border-[#2C7A4B]"
              : "border-background-300 bg-white hover:border-[#1A365D]"
          }`}
          aria-label={checked ? "Mark as incomplete" : "Mark as complete"}
        >
          {checked && <i className="ri-check-line text-white text-sm"></i>}
        </button>

        {/* Title */}
        <button
          className="flex-1 text-left flex items-center gap-2 cursor-pointer"
          onClick={() => setExpanded(!expanded)}
        >
          <span
            className={`font-semibold text-sm leading-snug ${
              checked ? "text-[#2C7A4B] line-through opacity-70" : "text-foreground-950"
            }`}
          >
            <span className="text-foreground-400 mr-1.5 font-normal">{number}.</span>
            {title}
            {tag && (
              <span className="ml-1.5 text-foreground-400 font-normal text-xs italic">
                {tag}
              </span>
            )}
          </span>
        </button>

        {/* Expand toggle */}
        <button
          onClick={() => setExpanded(!expanded)}
          className="flex-shrink-0 w-7 h-7 flex items-center justify-center text-foreground-400 hover:text-foreground-700 transition-colors cursor-pointer"
        >
          <i
            className={`text-base transition-transform duration-200 ${
              expanded ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"
            }`}
          ></i>
        </button>
      </div>

      {/* Expanded Body */}
      {expanded && (
        <div className="px-5 pb-5 pt-1 border-t border-background-200">
          <div className="text-sm text-foreground-600 leading-relaxed space-y-3 pl-9">
            {children}
          </div>
        </div>
      )}
    </div>
  );
}